'use client';

import Popper from '@mui/material/Popper';

import { usePopperContext } from './hooks';

import type { PopperProps } from '@mui/material/Popper';
import type { FC } from 'react';

export type PopperProviderProps = Omit<PopperProps, 'open'>;

/**
 * provides management of the anchor element and open/close state of the PopoverDisplay
 * requires a <AnchorElement> to consume event handler
 *
 * @example
 * ```jsx
 *   <PopperProvider>
 *     <PopoverDisplay>
 *       ...
 *     </PopoverDisplay>
 *   </PopperProvider>
 * ```
 */

export const PopperDisplay: FC<PopperProviderProps> = ({
  children,
  id: initialId,
  ...props
}) => {
  const {
    anchorEl,
    isOpen,
    id,
    placement,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    handleToggle,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    handleOpen,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    handleClose,
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    setAnchorEl,
    ...rest
  } = usePopperContext();

  return (
    <Popper
      id={id ?? initialId}
      anchorEl={anchorEl}
      open={isOpen}
      placeholder={placement}
      {...rest}
      {...props}
    >
      {children}
    </Popper>
  );
};
